import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('createBatteryForm');

    return {
        CREATE: t('create')
    };
};

export default useTranslation;
